import React from 'react';
import { RECORD_TYPES } from '../constants';

export default function RecordSelectionStep({
  formData,
  setFormData,
  handleRecordTypeToggle,
  deliveryErrors
}) {
  return (
    <div className="space-y-6">
      <h4 className="font-medium text-slate-900">What Records Do You Need?</h4>

      <div>
        <label className="block text-sm font-medium text-slate-700 mb-2">
          Record Types *
        </label>
        <div className="grid grid-cols-2 gap-2">
          {RECORD_TYPES.map(type => (
            <label
              key={type.value}
              className={`flex items-center gap-2 p-3 rounded-lg border cursor-pointer transition-colors ${
                formData.recordTypes.includes(type.value)
                  ? 'border-purple-500 bg-purple-50'
                  : 'border-slate-200 hover:bg-slate-50'
              }`}
            >
              <input
                type="checkbox"
                checked={formData.recordTypes.includes(type.value)}
                onChange={() => handleRecordTypeToggle(type.value)}
                className="w-4 h-4 text-purple-600 rounded"
              />
              <span className="text-sm">{type.label}</span>
            </label>
          ))}
        </div>
      </div>

      <div className="grid grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-slate-700 mb-1">
            Date Range (From)
          </label>
          <input
            type="date"
            value={formData.dateRangeStart}
            onChange={(e) => setFormData({ ...formData, dateRangeStart: e.target.value })}
            className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-slate-700 mb-1">
            Date Range (To)
          </label>
          <input
            type="date"
            value={formData.dateRangeEnd}
            onChange={(e) => setFormData({ ...formData, dateRangeEnd: e.target.value })}
            className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500"
          />
        </div>
      </div>

      <div>
        <label className="block text-sm font-medium text-slate-700 mb-1">
          Specific Records or Notes
        </label>
        <textarea
          value={formData.specificRecords}
          onChange={(e) => setFormData({ ...formData, specificRecords: e.target.value })}
          rows={3}
          className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500"
          placeholder="e.g., Lab results from January 2024 visit, MRI of left knee..."
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-slate-700 mb-1">
          Additional Notes (for provider)
        </label>
        <textarea
          value={formData.notes}
          onChange={(e) => setFormData({ ...formData, notes: e.target.value })}
          rows={3}
          className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500"
          placeholder="Include portal instructions, preferred contact, or any delivery details."
        />
        {deliveryErrors.portal && (
          <p className="text-xs text-red-600 mt-1">{deliveryErrors.portal}</p>
        )}
      </div>

    </div>
  );
}
